import {AttributeLink, AttributeSetup} from '@acng/frontend-stargazer';
import {Watch} from '@acng/frontend-relativity';
import {HIDDEN} from '@acng/frontend-bounty/dom/attribute.js';
import {remove} from '@acng/frontend-bounty/dom/move.js';

import {ctxAmateur} from '../../amateurPool/context/amateur.js';
import {picturePoolFeature} from '../config/feature.js';
import {SetGalleryCount} from '../../amateurPool/service/gallery-count.js';

/**
 * @group DOM Attribute
 */
export const SEDCARD_PICTURE_COUNT = 'data-sedcard-picture-count';

AttributeSetup(SEDCARD_PICTURE_COUNT, (name) => {
  const watch = Watch(`[${name}]`, ctxAmateur);
  const update = SetGalleryCount('picture');

  AttributeLink(name, () => (element) => {
    watch(element, update);
  });

  return (element) => {
    if (picturePoolFeature[HIDDEN]) {
      remove(element);
    }
  };
});
